//タームメニュー現在地表示
$(function(){
  $('.faq-cat__contents').each(function(){
    var target = $(this).attr('href');
    if(location.href.match(target)) {
      $(this).addClass('current');
    } else {
      $(this).removeClass('current');
    }
  });
});